import { GameData, Timing } from "../game-data.js";

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

export default class TechnologyCostFormulas {
    static _getTechnologyCost(level) {
        return Math.log(Math.pow(15, level)) * 100;
    }

    static _getResearchLabSpeedUp(research_level, lab_level) {
        return Timing.planet_getPlanetCenterSpeedUp(research_level, lab_level);
    }

    static getCostForIncrement(technology, level) {
        let money = technology.research_cost;
        money *= TechnologyCostFormulas._getTechnologyCost(level);
        return money;
    }

    static getTimeForIncrement(technology, level, lab_level) {
        if (technology.id === "astronomy") {
            return Math.ceil(MINUTE / GameData.SPEED);
        }
        let time = Timing.planet_getBuildingTimeForLevel(level + 10);
        time *= this._getResearchLabSpeedUp(level, lab_level);
        time *= technology.research_time;
        time *= HOUR;
        time /= GameData.SPEED;
        return Math.ceil(time);
    }
}